<template>
  <div class="lf-prompt">
    <div class="lf-prompt__inner">
      <span v-if="description" class="lf-prompt__message">{{ description }}</span>
      <span v-if="heading" class="lf-prompt__message">
        {{ heading }}
      </span>
      <span v-if="description && heading" class="lf-prompt__description">
        {{ description }}
      </span>
      <div class="lf-prompt__buttons">
        <button
          v-for="(button, index) in buttons"
          :key="index"
          type="button"
          class="lf-prompt__button btn btn-light btn-lg"
          :class="{
            [`lf-prompt__button--variant-${button.variant}`]: true
          }"
          @click.stop="$emit('buttonClicked', button.id)"
        >
          <span v-if="button.variant === 'text'">{{ button.label }}</span>
          <span v-if="button.variant === 'icon'" class="fa" :class="{ [`fa-${button.icon}`]: true }"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { PromptData } from '@/typings/interfaces/state/Editing';
import { ModalButton } from '@/components/components/editing/Modals/interfaces';

export default defineComponent({
  name: 'Prompt',
  props: {
    data: {
      type: Object as PropType<PromptData>
    },
    heading: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    buttons: {
      type: Array as PropType<ModalButton[]>,
      default: null
    }
  },
  emits: ['hidePrompt', 'buttonClicked'],
  setup(props, context) {
    const onClosePrompt = () => {
      context.emit('hidePrompt');
    };

    return {
      onClosePrompt
    };
  }
});
</script>

<style lang="scss" scoped>
.lf-prompt {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(#000, 0.75);
  width: 100%;
  height: 100%;
  z-index: 2000;
  color: #ffffff !important;

  &__inner {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &__message {
    display: block;
    font-size: 2.8rem;
    font-family: 'Gilroy', Helvetica, Arial, sans-serif;
    width: 100%;
    text-align: center;

    &::before {
      content: '\f12a';
      position: static;
      margin: 0 auto 2rem auto;
      width: 6.8rem;
      height: 6.8rem;
      border-radius: 50%;
      display: block;
      font-family: FontAwesome;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #fff;
      background: #dc3545;
      line-height: 7.2rem;
      text-align: center;
      font-size: 5rem;
      z-index: 1;
    }
  }

  &__description {
    display: block;
    font-size: 1.6rem;
    font-family: 'Gilroy', Helvetica, Arial, sans-serif;
    width: 100%;
    text-align: center;
  }

  &__buttons {
    width: 100%;
    text-align: center;
    margin-top: 3rem;
  }

  &__button {
    border-radius: 4px;
    height: auto;
    padding: 1.4rem 3rem 1.5rem 3rem;
    font-size: 1.2rem !important;
    font-weight: 700;
    letter-spacing: -0.5px;
    text-transform: uppercase;
    line-height: 1em;
    vertical-align: top;
    margin: 0 0.75rem;
    border: 0;
    background-color: grey !important;
    color: #fff !important;
    font-family: 'Gilroy', Helvetica, Arial, sans-serif;
    transition: background-color 125ms linear;

    &:hover {
      background-color: darken(grey, 5%) !important;
    }

    &:first-child {
      margin-left: 0;
      background-color: #dc3545 !important;

      &:hover {
        background-color: lighten(#dc3545, 5%) !important;
      }
    }
  }
}
</style>
